import Splide from "@splidejs/splide";

export default class SidebarSlider {
    constructor() {
        this.relatedProductsSlider = "";
        this.slider = document.querySelector(".related-products__slider");
        this.events();
    }

    events() {
        if (this.slider) {
            this.initializeProductsSlider();
        }
    }

    initializeProductsSlider() {
        this.relatedProductsSlider = new Splide(this.slider, {
            type: "slide",
            pagination: false,
            perPage: 3,
            perMove: 1,
            gap: 30,
            arrows: false,
            padding: {
                right: "13rem",
            },
            breakpoints: {
                1300: {
                    gap: 20,
                },
                576: {
                    perPage: 2,
                    padding: {
                        right: "10rem",
                    },
                },
            },
        }).mount();
    }
}
